<template>
  <section class="slide-5 px-4.5">
    <div class="flex items-center section-header mb-8">
      <svg width="40" class="w-9.375 mr-8" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M38.75 26.25C38.75 27.3551 38.311 28.4149 37.5296 29.1963C36.7482 29.9777 35.6884 30.4167 34.5833 30.4167H9.58333L1.25 38.75V5.41667C1.25 4.3116 1.68899 3.25179 2.47039 2.47039C3.25179 1.68899 4.3116 1.25 5.41667 1.25H34.5833C35.6884 1.25 36.7482 1.68899 37.5296 2.47039C38.311 3.25179 38.75 4.3116 38.75 5.41667V26.25Z" stroke="#97A3CB" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.5 11.5H30" stroke="#97A3CB" stroke-opacity="0.3" stroke-width="2"/>
        <path d="M10 20H21" stroke="#97A3CB" stroke-opacity="0.3" stroke-width="2"/>
      </svg>
      <p class="uppercase font-medium fz-10" style="line-height: 1; color: #6e758d; letter-spacing: 0.3rem" >{{ text.agencyName }}</p>
    </div>
    <p class="fz-16 text-justify font-medium text-white mb-12.5" style="line-height: 1.875;">{{ text.text }}</p>
    <div class="flex mb-12.5">
      <img src="@/assets/images/slide_5/max_photo-m.png" class="w-55" alt="">
      <div class="flex flex-col ml-auto">
        <div class="p-3.5 rounded-full border-2 mb-5" style="border-color: rgba(151, 163, 203, 0.3)">
          <img
              src="@/assets/images/wiki.svg"
              class="w-5 h-5"
              alt=""
          />
        </div>
        <div class="p-3.5 rounded-full border-2" style="border-color: rgba(151, 163, 203, 0.3)">
          <img
              src="@/assets/images/fb.svg"
              class="w-5 h-5"
              alt=""
          />
        </div>

      </div>
    </div>
    <a href="#mobile-start" class="agency flex items-center" @click="setRoute('agency')">
      <div class="plus relative w-12.5 h-12.5 mr-5 rounded-full" style="background:#fff;" >
        <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#ff2e53;"></div>
        <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#ff2e53;"></div>
      </div>
      <p class="uppercase fz-13 font-semibold mr-5" style="line-height: 1;">{{ text.agency }}</p>

    </a>
  </section>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "slide5",
  methods:{
    ...mapMutations(['setRoute'])
  },
  computed:{
    text(){
      return require('@/assets/text/main/slide5/' + this.lang + '.json')
    },
    ...mapState(['lang'])
  }
}
</script>

<style scoped>

</style>
